import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Books from '../views/Books.vue'
import notFound from '../views/404.vue'
import i18n from '../i18n' // Assuming your i18n instance is exported from this path

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    component: notFound,
  },
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/books/:id',
    name: 'books',
    component: Books
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // Add scrollBehavior to handle anchor links
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      // Scroll to the element with the ID matching the hash
      return {
        selector: to.hash,
        // Optional: Add an offset if you have a fixed header/navbar
        // offset: { x: 0, y: 70 } 
      }
    } else {
      // Scroll to the top of the page for other navigations
      return { x: 0, y: 0 }
    }
  }
})

// Add a navigation guard to handle locale from route parameters
router.beforeEach((to, from, next) => {
  // Check if a locale parameter is present in the route object
  // and if it's different from the current i18n locale
  if (to.params.locale && i18n.locale !== to.params.locale) {
    i18n.locale = to.params.locale;
  }
  // Make sure a default locale is set if none is provided via params
  // This helps when navigating directly to '/' without a locale param
  if (!i18n.locale) {
    i18n.locale = 'en'; // Or your application's default locale
  }
  next(); // Continue to the next route
});

export default router
